// Chinese (mandarin)

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `开放截止时间：${date}` : ''),
    },
    interview: {
      title: '回答该视频面试',
      submit: '提交回答并完成面试',
      continueLater: '稍候继续',
      startInterview: '开始面试',
      duplicateError: '您已参加本次面试。您已从invitations@recright.com收到一份电子邮件，其中包含一个链接，可用于稍后继续该面试。',
      confirmSubmitHeader: '您尚未回答所有面试问题',
      confirmSubmitContent: '您是否真的希望现在就完成该面试？',
      confirmSubmitContentWarning: '如果确认此操作，您将后续无法继续您的回答。',
      submitInterviewHeader: '提交面试回答',
      submitInterviewContent: '确定要提交面试？',
      confirmSubmitButton: '提交回答并完成面试',
      preview: '您可在此预览视频问题。',
      requiredQuestionsNotAnswered: '提交前请回答所有必填问题。',

      withdrawLink: '已经对这个岗位失去兴趣了？您可以在这里退出应聘流程。',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: '姓名',
      city: '家乡',
      email: '电子邮箱',
      phone: '电话',
      link: '链接',
      legendBasicInfo: '基本资料',
      placeholderName: '请输入您的姓名',
      placeholderEmail: '请输入您的电子邮件',
      placeholderPhone: '请输入您的电话',
      placeholderCity: '请输入您当前城市',
      placeholderLink: '添加链接，例如，您的LinkedIn个人资料页面。',
      legendAttachments: '附件',
      legendAdditionalFields: '额外资料',
      required: '*星号标记的项目为必填项目。',
    },

    sequencedInterview: {
      networkTest: {
        audio: '音频',
        video: '视频',
        yes: '是',
        no: '否',
        supported: '支持',
        quality: '质量',
        header: '网络连接与设备测试',
        description: '现在我们将运行一项测试，以确保您面试所需的网络连接与硬件均正常工作。当出现提示时，请允许测试程序使用您的摄像头与麦克风，并请确保您的摄像头未被遮挡。此测试将持续约 30 秒。我们建议您在硬件测试过程中说一些话。',
        inProgress: '正在进行测试…',
        networkTestResults: '网络测试结果',
        qualityTestResults: '质量测试结果',
        testPassedQuality: '已通过质量测试',
        testFailedQuality: '质量测试失败',
        testPassedNetwork: '网络测试通过',
        testFailedNetwork: '网络测试失败',
        startTest: '开始测试',
        startInterview: '开始面试',
        testAgain: '再次测试',
        confirmWarning: '视频面试开始后，系统将自动跳转到第一道面试题。待您阅读完毕后，即进入准备阶段。',
        confirmTitle: '您即将开始面试',
        confirmText: '回答每道问题之前，您都会有一小段准备时间。准备完毕后，您需要在预设的时间内回答问题。请注意，您在作答完成后即可提交答案，无需等待预设时间结束。',
        confirmText2: '答案提交后，系统将跳转至下一道题，直至您将所有问题回答完毕为止。',
        confirmText3:
          '请注意：录制完一道问题的答案后，如果该问题允许重新答题，将有 30 秒的时间供您重新答题。如果您在 30 秒内未启动重新答题，则当前答案将自动提交，您将转至下一题。',
        goodLuck: '来个深呼吸，相信自己。祝你好运！',
        qualityRating: {
          excellent: '优异',
          good: '良好',
          fair: '一般',
          poor: '较差',
          bad: '很差',
        },
      },
      questionAnswerView: {
        title: title => `接受面试 ${title}`,
        question: '问题',
        submitAndNext: '提交并回答下一题',
        submitSuccess: '视频提交成功！',
        skipText: '开始录像',
        stop: '停止',
        submitAndFinish: '提交并结束此次面试',
        retake: '重新开始',
        take: '开始',
        takesLeft: '继续余下面试',
        skipTextQuestion: '准备好了吗？继续进行',
        retakeConfirmTitle: '是否确定要重新回答此问题？',
        retakeConfirmSubmit: '是的，开始重新答题',
        submitInfoForward: '距自动提交当前答案并继续下一题还有',
        submitInfoForward2: '秒',
        nonAnswerableText: '您不需耀答覆這短訊。收到這短訊後，您會被導引到下一個問題。',
        nonAnswerableVideo: '您不需要答覆這段視頻。收到這段視頻後，您會被導引到下一個問題。',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `您有 ${answerMinutes} 分钟和 ${answerSeconds} 秒的时间来回答问题。`,
      },
      publisher: {
        toNextQuestion: timer => `${timer} 后将跳转至下一问题`,
        recordingStarts: timer => `${timer} 后将开始录像`,
      },
      errors: {
        tooManyConnections: '此连接已关闭，原因是您已在另一选项卡或窗口内中建立了连接。',
        unsupportedBrowser: '很遗憾，您的浏览器不支持此操作。请使用其他浏览器。',
        networkError: '没有互联网连接。',
        reconnecting: '连接中断。正在尝试重新连接。',
        generalError: '发生错误。请刷新页面并重试。',
        allowMediaDevicesError: '此操作无法获取媒体设备（摄像头或麦克风）。请确保您已允许浏览器使用您的摄像头与麦克风。',
        noAvailableDevicesError: '我们无法找到摄像头和麦克风。',
        initPublisherError: '发生错误导致操作失败。请确保您已允许浏览器使用您的摄像头与麦克风，并且这些设备未被其他应用程序使用，随后请重试。',
      },
      browserInfo: {
        browserSupportTitle: '浏览器支持',
        supportedBrowsers: '此项测试与面试支持最新版本的 Chrome、Firefox、Safari 与 Edge 浏览器。',
        mobileSupported: '在移动端上支持的浏览器',
        android: 'Android：Google Chrome（最新发行版本）、Firefox（最新发行版本）',
        iOS: 'iOS：Safari（最新发行版本）',
        latestVersion: '请确保您使用的是这款浏览器的最新发行版本，以确保一切运转正常。',
        freezeInstruction: '如视频录制并未开始，或是录制出来的画面始终为黑屏状态，请刷新页面。',
        unsupportedOnIos: '看起来您正在 iOS 上使用不受支持的浏览器。请改用 Safari。',
        ieUnsupported: '看起来您正在使用 Internet Explorer。很遗憾，此项测试或面试不支持 Internet Explorer。请改用其他浏览器。',
        qualityTestNotSupported: '很遗憾，您使用的浏览器不支持硬件测试。您可以在不测试音频与视频质量的情况下继续进行面试，也可以改用其他浏览器。',
      },
      reconnectSuccess: '重新连接成功！',
      continue: '继续',
    },

    withdraw: {
      title: '已经对这个职位失去兴趣了？',
      description: '自行退出应聘流程。',
      buttonText: '退出应聘流程',
      thankYouTitle: '谢谢！',
      thankYouText: '您已经告知招聘人员，说您已经对这个岗位失去兴趣了。',
      confirm: '确定要退出应聘流程？退出之后，您将无法回应与该岗位有关的任何面试（包括本场面试在内）。',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: '提交',
      continue: '继续',
      supportCenter: 'Recright Help Center',
      thankYou: '感谢您的视频回答！我们将尽快与您联系！',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: '感谢您参加面试！',
      reopenDescription: '即便您不小心关闭了面试页面，那也没有关系！只需点击下面的按钮，即可重新打开面试页面！',
      reopenButtonText: '重新打开面试页面',
      description1: '非常棒！您已回答所有问题，并且已将其发送给招聘人员。',
      descriptionsupport: mailto => `如果您意外关闭本面试，请联系我们的客服 ${mailto}，我们将帮助您重新启动面试。`,
      descriptionfeedback: '您的体验对我们非常重要！您回答视频面试的体验如何？您认为我们可以如何提升我们的服务？请在此留下您的反馈。',
      feedbackbutton: '向我们提供您的反馈！',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: '个人消息',
    },

    closed: {
      title: '面试已完成',
      description: '您受邀参加的视频面试已结束，或者，您已完成并提交该面试。',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: '您的视频面试已保存！',
      description: '如果您希望稍后继续视频面试，请查看您的电子邮件中继续申请的链接继续您的面试申请。当前已录制的视频回答将会保存在系统中，祝您求职好运！',
      remember: '在您完成面试回答之后，请记得提交申请，我们将发送您的申请给招聘人员。',
      deleteHistory: '如果您在公用计算机上进行视频面试，请记得最后清空您的浏览器历史记录。这样可确保您面试的安全性。',
    },
    unpublished: {
      title: '面使尚未开始',
      publishTime: publishTime => `面试将在 ${publishTime} 开始`,
    },
  },
}
